import { startsWith, endsWith, replace } from "lodash"

export default function handleUrl(link) {
  if (!link) {
    return "#"
  }

  if (link.linktype === "story" && link.id) {
    if (link.cached_url !== "hult/home" && link.cached_url !== "home") {
      let handledLink = link.cached_url

      if (startsWith(handledLink, "hult/"))
        handledLink = replace(handledLink, /^hult\/(.*)/, "$1")
      if (!endsWith(handledLink, "/")) handledLink += "/"
      return `/${handledLink}`
    }
    return "/"
  }
  return link.url
}

export function parseLink(url) {
  if (!url) {
    return "#"
  }

  if (startsWith(url, "/hult/en")) {
    url = `/${replace(url, /^\/hult\/(.*)/, "$1")}`
  }
  return url
}
